export enum NcisBasemapType {
  ODD = 'ODD',
  EVEN = 'EVEN'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/ncisbasemaptype.ts